<template src="./pagina-nao-encontrada.html"></template>
<style lang="less" scoped src="./pagina-nao-encontrada.less"></style>

<script>
    import BackgroundHeader from '@/components/headers/background-header/background-header'
    import FieldArea from '@/components/field-area/field-area'

    export default {
        components: {
            BackgroundHeader,
            FieldArea
        }
    }
</script>